import React from 'react';
import { Container, Typography, List, ListItem, ListItemText } from '@mui/material';

const Support = () => {
  const supportContacts = [
    { name: 'Counseling Hotline', number: '+254712 345 678' },
    { name: 'Legal Support', number: '+254713 456 789' },
  ];

  return (
    <Container>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
        Support
      </Typography>
      <List>
        {supportContacts.map((contact, index) => (
          <ListItem key={index}>
            <ListItemText
              primary={contact.name}
              secondary={
                <a href={`tel:${contact.number}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                  {contact.number}
                </a>
              }
            />
          </ListItem>
        ))}
      </List>
    </Container>
  );
};

export default Support;